import React, { createContext, useContext, useEffect, useState } from 'react'

import { useAccountReadContext } from '@context/AccountContextContext'

type NavigationMode = 'trader' | 'partner'

interface NavigationModeContextType {
  navigationMode: NavigationMode
  setNavigationMode: (mode: NavigationMode) => void
}

const NavigationModeContext = createContext<NavigationModeContextType>({
  navigationMode: 'trader',
  setNavigationMode: () => {},
})

export const NavigationModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { account } = useAccountReadContext()

  const [navigationMode, setNavigationMode] = useState<NavigationMode>(() => {
    return (localStorage.getItem('navigationMode') as NavigationMode) ?? 'trader'
  })

  const handleSetNavigationMode = (mode: NavigationMode) => {
    setNavigationMode(mode)
    localStorage.setItem('navigationMode', mode)
  }

  useEffect(() => {
    const isIntroducingBrokerPath = window.location.pathname.includes('introducing-broker')
    const hasIB = Boolean(account?.clientIntroducingBroker?.id)

    if (hasIB && isIntroducingBrokerPath) {
      handleSetNavigationMode('partner')
    } else {
      handleSetNavigationMode('trader')
    }
  }, [account])

  return (
    <NavigationModeContext.Provider
      value={{ navigationMode, setNavigationMode: handleSetNavigationMode }}
    >
      {children}
    </NavigationModeContext.Provider>
  )
}

export const useNavigationMode = () => useContext(NavigationModeContext)
